import { getDeviceType } from '@/utils/device';

import { getIdentity, hasAnalyticsConsent } from './identity';
import { sendOne } from './queue';
import type { TrackedEvent } from './types';

/**
 * Assemble the event envelope and send it immediately (one request per event).
 * Consent is re-checked lazily on every call and gates everything: with no
 * analytics consent nothing is sent and — order is load-bearing — no session is
 * minted and no activity is refreshed. Identity is minted after the consent
 * check and passed to transport (it flows into X-SB-* headers, not the
 * envelope).
 */
export const track = (event_type: string, payload: Record<string, unknown> = {}): void => {
    if (!hasAnalyticsConsent()) return;

    const identity = getIdentity();
    const event: TrackedEvent = {
        event_type,
        timestamp: Date.now(),
        device: getDeviceType(),
        page: { page_type: document.body?.dataset.pageId ?? null },
        payload,
    };

    sendOne(event, identity);
};
